// 2P AI — command bar in alto (sticky): marchio + spaziatore + azioni (es. "Nuova sessione")
// + toggle tema + impostazioni.
import type { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { Brand } from './Brand';
import { ThemeToggle } from './ThemeToggle';
import { IconButton } from './IconButton';

export function CommandBar({ actions, onSettings }: { actions?: ReactNode; onSettings?: () => void }) {
  const [, navigate] = useLocation();
  return (
    <header className="bar">
      <Brand />
      <div className="spacer" />
      {actions}
      <IconButton icon="data_usage" label="Utilizzo" onClick={() => navigate('/usage')} />
      <ThemeToggle />
      {onSettings ? <IconButton icon="settings" label="Impostazioni" onClick={onSettings} /> : null}
    </header>
  );
}
